import { render, staticRenderFns } from "./PluginTextEditor.vue?vue&type=template&id=6ca1ffc6&"
import script from "./PluginTextEditor.vue?vue&type=script&lang=ts&"
export * from "./PluginTextEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports